import * as React from 'react';
import ENV from '../../base/env';
import './SmileySlider.scss';

export interface ISmileySliderProps {
  value: number;
  min: number;
  max: number;
  className?: string;
  onChange?: (value: number) => void;
  onChangeEnd?: (value: number) => void;
}

export const SmileySlider: React.FC<ISmileySliderProps> = ({ min, max, value, onChange, onChangeEnd, className }) => {
  const [currentValue, setCurrentValue] = React.useState(value);
  const step = 1;
  const options = [1, 2, 3, 4, 5];
  let minValue = min;
  let disabled = false;
  if (min === max) {
    // if value can not be changed - disable input and apply a visual hack to keep looking nice
    minValue = min - 1;
    disabled = true;
  }

  const smileySrc = {
    1: `url(${ENV.AssetsBaseUrl}/feature/mood-tracker/smiley_1.svg)`,
    2: `url(${ENV.AssetsBaseUrl}/feature/mood-tracker/smiley_2.svg)`,
    3: `url(${ENV.AssetsBaseUrl}/feature/mood-tracker/smiley_3.svg)`,
    4: `url(${ENV.AssetsBaseUrl}/feature/mood-tracker/smiley_4.svg)`,
    5: `url(${ENV.AssetsBaseUrl}/feature/mood-tracker/smiley_5.svg)`,
  };

  const style = { '--min': minValue, '--max': max, '--val': currentValue, '--smiley': smileySrc[currentValue] };
  const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setCurrentValue(+e.target.value);
    if (onChange) onChange(+e.target.value);
  };
  const onMouseUpHandler = () => {
    if (onChangeEnd) onChangeEnd(currentValue);
  };

  const getOptionClassName = (optionValue: number) => (currentValue >= optionValue ? 'active' : '');

  return (
    <div className={`smileySlider ${className ?? ''}`}>
      <input
        style={style as React.CSSProperties}
        type="range"
        min={minValue}
        max={max}
        value={value}
        onChange={onChangeHandler}
        onMouseUp={onMouseUpHandler}
        disabled={disabled}
        step={step}
        list="steps"
      />
      <datalist id="steps">
        {options.map((n) => (
          <option key={n} value={n} className={getOptionClassName(n)}></option>
        ))}
      </datalist>
    </div>
  );
};

export default SmileySlider;
